import AirConditioner from '../../asset/air-conditioner.svg'
import AirPurifier from '../../asset/air-purifier.svg'
import Apartment from '../../asset/apartment.svg'
import Balcony from '../../asset/balcony.svg'
import Bathtub from '../../asset/bathtub.svg'
import Bed from '../../asset/bed.svg'
import Bidet from '../../asset/bidet.svg'
import CableTV from '../../asset/cable-tv.svg'
import CCTV from '../../asset/cctv.svg'
import Closet from '../../asset/closet.svg'
import Curtain from '../../asset/curtain.svg'
import Desk from '../../asset/desk.svg'
import Detached from '../../asset/detached.svg'
import DiningTable from '../../asset/dining-table.svg'
import Doorlock from '../../asset/doorlock.svg'
import DressingRoom from '../../asset/dressing-room.svg'
import Dryer from '../../asset/dryer.svg'
import DuplexStructure from '../../asset/duplex-structure.svg'
import Electricity from '../../asset/electricity.svg'
import Elevator from '../../asset/elevator.svg'
import GasStove from '../../asset/gas-stove.svg'
import Gas from '../../asset/gas.svg'
import Gosiwon from '../../asset/gosiwon.svg'
import GuestHouse from '../../asset/guest-house.svg'
import Hotel from '../../asset/hotel.svg'
import Induction from '../../asset/induction.svg'
import Kitchen from '../../asset/kitchen.svg'
import LivingRoom from '../../asset/living-room.svg'
import ManagementOffice from '../../asset/management-office.svg'
import Microwave from '../../asset/microwave.svg'
import MixedUse from '../../asset/mixed-use.svg'
import Motel from '../../asset/motel.svg'
import Officetel from '../../asset/officetel.svg'
import Parking from '../../asset/parking.svg'
import PetAllowed from '../../asset/pet-allowed.svg'
import PropertyType from '../../asset/property-type.svg'
import PyeongSize from '../../asset/pyeong-size.svg'
import Refrigerator from '../../asset/refrigerator.svg'
import Restroom from '../../asset/restroom.svg'
import RiceCooker from '../../asset/rice-cooker.svg'
import Room from '../../asset/room.svg'
import ShareHouse from '../../asset/share-house.svg'
import ShoeRack from '../../asset/shoe-rack.svg'
import Sink from '../../asset/sink.svg'
import Sofa from '../../asset/sofa.svg'
import Studio from '../../asset/studio.svg'
import TV from '../../asset/tv.svg'
import VacationHome from '../../asset/vacation-home.svg'
import Vanity from '../../asset/vanity.svg'
import Villa from '../../asset/villa.svg'
import WashingMachine from '../../asset/washing-machine.svg'
import WaterPurifier from '../../asset/water-purifier.svg'
import Water from '../../asset/water.svg'
import Wifi from '../../asset/wifi.svg'

export const ICON = {
  airConditioner: AirConditioner,
  airPurifier: AirPurifier,
  apartment: Apartment,
  balcony: Balcony,
  bathtub: Bathtub,
  bed: Bed,
  bidet: Bidet,
  cableTV: CableTV,
  cctv: CCTV,
  closet: Closet,
  curtain: Curtain,
  desk: Desk,
  detached: Detached,
  diningTable: DiningTable,
  doorlock: Doorlock,
  dressingRoom: DressingRoom,
  dryer: Dryer,
  duplexStructure: DuplexStructure,
  electricity: Electricity,
  elevator: Elevator,
  gasStove: GasStove,
  gas: Gas,
  gosiwon: Gosiwon,
  guestHouse: GuestHouse,
  hotel: Hotel,
  induction: Induction,
  kitchen: Kitchen,
  livingRoom: LivingRoom,
  managementOffice: ManagementOffice,
  microwave: Microwave,
  mixedUse: MixedUse,
  motel: Motel,
  officetel: Officetel,
  parking: Parking,
  petAllowed: PetAllowed,
  propertyType: PropertyType,
  pyeongSize: PyeongSize,
  refrigerator: Refrigerator,
  restroom: Restroom,
  riceCooker: RiceCooker,
  room: Room,
  shareHouse: ShareHouse,
  shoeRack: ShoeRack,
  sink: Sink,
  sofa: Sofa,
  studio: Studio,
  tv: TV,
  vacationHome: VacationHome,
  vanity: Vanity,
  villa: Villa,
  washingMachine: WashingMachine,
  waterPurifier: WaterPurifier,
  water: Water,
  wifi: Wifi,
}

export type RoomIconName = keyof typeof ICON
